export default __webpack_public_path__ + "static/media/会议中心_white.9f9ce29e.jpg";